import {
  Heart, Lightbulb, ShieldCheck, MessageCircle, UserPlus, BookOpen, Sparkles,
  Brain, Key, Compass, Star, Quote, Crown, Gem, Flame, Sun, Moon, Wind, Mountain,
  Feather, TreePine, Anchor, Globe, Eye, Target, Zap, Award, CheckCircle, Circle,
  HeartHandshake, Users, Coffee, Music, MessageSquare, Send, BookmarkCheck,
  ScrollText, Notebook, Pen, Edit, Search, Check, FileText, Image as ImageIcon,
  HelpCircle
} from 'lucide-react';

// Maps mobile/ionicons-style names + lucide names to a lucide component.
const MAP = {
  'heart': Heart, 'love': Heart, 'heart-outline': Heart, 'heart-fill': Heart,
  'bulb': Lightbulb, 'lightbulb': Lightbulb, 'idea': Lightbulb, 'knowledge': Lightbulb,
  'shield-checkmark': ShieldCheck, 'shield': ShieldCheck, 'honesty': ShieldCheck, 'check-shield': ShieldCheck,
  'chatbubble': MessageCircle, 'chat': MessageCircle, 'message': MessageCircle, 'message-circle': MessageCircle,
  'message-square': MessageSquare, 'send': Send,
  'person-add': UserPlus, 'user-plus': UserPlus, 'users': Users,
  'book': BookOpen, 'book-open': BookOpen, 'reader': BookOpen,
  'sparkles': Sparkles, 'star': Star, 'shine': Sparkles,
  'brain': Brain, 'mind': Brain, 'cortex': Brain,
  'key': Key, 'unlock': Key,
  'compass': Compass, 'guide': Compass,
  'quote': Quote, 'crown': Crown, 'gem': Gem,
  'flame': Flame, 'fire': Flame,
  'sun': Sun, 'moon': Moon, 'wind': Wind,
  'mountain': Mountain, 'feather': Feather,
  'tree': TreePine, 'anchor': Anchor, 'globe': Globe, 'eye': Eye,
  'target': Target, 'zap': Zap, 'lightning': Zap, 'award': Award,
  'check': CheckCircle, 'check-circle': CheckCircle, 'circle': Circle,
  'handshake': HeartHandshake, 'companion': HeartHandshake,
  'coffee': Coffee, 'music': Music, 'bookmark': BookmarkCheck,
  'scroll': ScrollText, 'notebook': Notebook, 'pen': Pen, 'edit': Edit,
  'search': Search, 'file': FileText, 'image': ImageIcon,
};

export function getIcon(name) {
  if (!name) return Sparkles;
  const key = String(name).toLowerCase().trim();
  return MAP[key] || Sparkles;
}

export const ICON_OPTIONS = [
  'sparkles','heart','lightbulb','shield-checkmark','book-open','brain','key','compass','star','quote','crown','gem','flame','sun','moon','wind','mountain','feather','anchor','globe','eye','target','zap','award','check-circle','handshake','users','coffee','music','message-circle','bookmark','scroll','notebook','pen','edit'
];
